module.exports = __webpack_public_path__ + "static/img/5810_phase_function_Paper_PointsHejduk_Prediction.8493697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5810_phase_function_Paper_PointsHejduk_Prediction.png
// module id = V22R
// module chunks = 0